import Count, {SELECTORS as COUNT_SELECTORS} from '../../../Components/Count/Count';

import '../../../Components/Count/_index.scss';

$(COUNT_SELECTORS.root).each((i, count) => {
    new Count(count);
});